export const TopBar = {
  flow: 'x',
  align: 'center space-between',
  padding: 'A B',
  borderBottom: '1px solid inkBorder',
  background: 'ink',
  PageTitle: { tag: 'h1', text: (el, s) => {
    var path = window.location.pathname
    if (path === '/ai') return '{{ aiAssistant | polyglot }}'
    if (path === '/patient') return '{{ navPatients | polyglot }}'
    if (path === '/chart') return '{{ navChart | polyglot }}'
    if (path === '/perio') return '{{ navPerio | polyglot }}'
    if (path === '/treatment-plan') return '{{ navTreatmentPlans | polyglot }}'
    if (path === '/clinical-notes') return '{{ navNotes | polyglot }}'
    if (path === '/scheduling') return '{{ navScheduling | polyglot }}'
    if (path === '/billing') return '{{ navBilling | polyglot }}'
    if (path === '/prescriptions') return '{{ navPrescriptions | polyglot }}'
    if (path === '/lab-cases') return '{{ navLabCases | polyglot }}'
    if (path === '/referrals') return '{{ navReferrals | polyglot }}'
    if (path === '/reports') return '{{ navReports | polyglot }}'
    if (path === '/medical-history') return '{{ navMedHistory | polyglot }}'
    if (path === '/enterprise') return '{{ navEnterprise | polyglot }}'
    if (path === '/integrations') return '{{ navIntegrations | polyglot }}'
    return '{{ navDashboard | polyglot }}'
  }, fontSize: 'B', fontWeight: '700', color: 'inkText' },
  TopBarRight: {
    flow: 'x', gap: 'Z', align: 'center center',
    SearchBox: {
      tag: 'input',
      type: 'text',
      placeholder: '{{ searchByName | polyglot }}',
      padding: 'Z A',
      round: 'C',
      background: 'inkSurface',
      color: 'inkText',
      border: '1px solid inkBorder',
      fontSize: 'Z',
      width: 'G',
      outline: 'none',
      transition: 'border 0.2s ease',
      ':focus': { border: '1px solid inkSubtle' }
    },

    LangSwitcher: {
      position: 'relative',
      LangBtn: {
        tag: 'button',
        flow: 'x',
        align: 'center center',
        gap: 'W',
        padding: 'X Z',
        round: 'Z',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        ':hover': { background: 'inkSurface' },
        onClick: (e, el, s) => {
          e.stopPropagation()
          s.root.update({ activeLangMenu: !s.root.activeLangMenu })
        },
        LangFlag: {
          fontSize: 'A',
          text: (el, s) => {
            var flags = { en: '\uD83C\uDDEC\uD83C\uDDE7', ka: '\uD83C\uDDEC\uD83C\uDDEA', ru: '\uD83C\uDDF7\uD83C\uDDFA', uk: '\uD83C\uDDFA\uD83C\uDDE6', tr: '\uD83C\uDDF9\uD83C\uDDF7', zh: '\uD83C\uDDE8\uD83C\uDDF3', hi: '\uD83C\uDDEE\uD83C\uDDF3', msa: '\uD83C\uDDF8\uD83C\uDDE6' }
            return flags[s.root.lang] || flags.en
          }
        },
        LangCode: {
          fontSize: 'Z',
          fontWeight: '600',
          color: 'inkSubtle',
          text: (el, s) => (s.root.lang || 'en').toUpperCase()
        }
      },
      LangDropdown: {
        flow: 'y',
        show: (el, s) => s.root.activeLangMenu,
        position: 'absolute',
        top: '100%',
        right: '0',
        marginTop: 'Y',
        background: 'inkMid',
        border: '1px solid inkBorder',
        round: 'Z',
        padding: 'Y 0',
        minWidth: 'F',
        zIndex: '100',
        boxShadow: '0 A B inkBorder',
        LangEn: { extends: 'LangOption', state: { langCode: 'en', flag: '\uD83C\uDDEC\uD83C\uDDE7', name: 'English' } },
        LangKa: { extends: 'LangOption', state: { langCode: 'ka', flag: '\uD83C\uDDEC\uD83C\uDDEA', name: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8' } },
        LangRu: { extends: 'LangOption', state: { langCode: 'ru', flag: '\uD83C\uDDF7\uD83C\uDDFA', name: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439' } },
        LangUk: { extends: 'LangOption', state: { langCode: 'uk', flag: '\uD83C\uDDFA\uD83C\uDDE6', name: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430' } },
        LangTr: { extends: 'LangOption', state: { langCode: 'tr', flag: '\uD83C\uDDF9\uD83C\uDDF7', name: 'T\u00FCrk\u00E7e' } },
        LangZh: { extends: 'LangOption', state: { langCode: 'zh', flag: '\uD83C\uDDE8\uD83C\uDDF3', name: '\u4E2D\u6587' } },
        LangHi: { extends: 'LangOption', state: { langCode: 'hi', flag: '\uD83C\uDDEE\uD83C\uDDF3', name: '\u0939\u093F\u0928\u094D\u0926\u0940' } },
        LangMsa: { extends: 'LangOption', state: { langCode: 'msa', flag: '\uD83C\uDDF8\uD83C\uDDE6', name: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629' } }
      }
    },

    BellIcon: { extends: 'Icon', icon: 'bell', width: 'A', height: 'A', color: 'inkMuted', cursor: 'pointer' },
    UserAvatar: {
      text: 'DL', width: 'B1', height: 'B1', round: 'D', background: 'inkText', color: 'white', fontWeight: '700', fontSize: 'Z', flow: 'x', align: 'center center'
    }
  }
}
